function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgContrastBlackLight = function SvgContrastBlackLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19.935
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m11.322 21.234-2.974-2.886h-4.1v-4.1L1.3 11.3l2.952-2.952v-4.1h4.1l2.97-2.948 2.93 2.952h4.1v4.1L21.3 11.3l-2.952 2.952v4.1h-4.1zm0-4.207a5.484 5.484 0 0 0 4.042-1.674 5.565 5.565 0 0 0 1.663-4.075 5.678 5.678 0 0 0-5.7-5.7zm0 2.357 2.378-2.357h3.326V13.7l2.4-2.4-2.4-2.4V5.573H13.7l-2.379-2.4-2.421 2.4H5.573V8.9l-2.4 2.4 2.4 2.4v3.326h3.3zm-.022-8.106z",
    transform: "translate(-1.301 -1.3)",
    style: {
      fill: "currentColor"
    }
  }));
};

export default SvgContrastBlackLight;